import {red} from "@mui/material/colors";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";
import {Typography} from "@mui/material";
import React from "react";
import {OverridableStringUnion} from "@mui/types";
import {Variant} from "@mui/material/styles/createTypography";
import {TypographyPropsVariantOverrides} from "@mui/material/Typography/Typography";

export const AccountStatus = (props:{ status: string | undefined, variant?:  OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>}) => {
    const theme = useTheme();
    const {t} = useTranslation();
    
    let properties = {name: "", color: ""};
    switch (props.status) {
        case 'Active':
        case 'Unverified':
            properties= {name: t('active'), color: theme.palette.success.light};
            break;
        case 'PendingVerification':
            properties= {name: t('actionRequired'), color: theme.palette.primary.main};
            break;
        case 'SelfExcludedTemporarily':
        case 'SelfExcludedIndefinitely':
            properties= {name: t('limitedAccess'), color: red["700"]};
            break;
        default:
            properties= {name: "", color: ""}
    }
    
    return ( <Typography variant={props.variant ?? 'body2'}
    sx={{color: properties.color}}>{properties.name}</Typography>)
}